import { Drawer } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import SigninOverlay from "./overlays/SigninOverlay";
import RegisterOverlay from "./overlays/RegisterOverlay";
import AccountOverlay from "./overlays/AccountOverlay";
import ForgotPasswordOverlay from "./overlays/ForgotPasswordOverlay";
import ResetPasswordOverlay from "./overlays/ResetPasswordOverlay";
import { ReactComponent as Whiteclose } from "../assets/images/white-close.svg";
import { connect } from "react-redux";
import {
  selectHomeSlideId,
  selectOverlayFlags,
  selectemployeeData,
} from "../store/home/home.selectors";
import { bindActionCreators } from "redux";
import { setEmployeeData } from "../store/home/home.actions";
import AppConfig from "../config/app.config";
import { swiper } from "../views/home/home";

const mapStateToProps = (state) => {
  return {
    employeeData: selectemployeeData(state),
    overlayFlags: selectOverlayFlags(state),
    homeSlideId: selectHomeSlideId(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      setEmployeeData,
    },
    dispatch
  ),
});

class AppHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: false,
      isSigninOverlayVisible: false,
      isRegisterOverlayVisible: false,
      isAccountOverlayVisible: false,
      isForgotPasswordOverlayVisible: false,
      isResetPasswordOverlayVisible: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      showRegisterOverlayFlag,
      showSigninOverlayFlag,
      showAccountOverlayFlag,
      showForgotPasswordOverlayFlag,
      showResetPasswordOverlayFlag,
    } = this.props.overlayFlags;
    if (
      showRegisterOverlayFlag !== prevProps.overlayFlags.showRegisterOverlayFlag
    ) {
      this.setState({
        isDrawerOpen: false,
        isSigninOverlayVisible: false,
        isRegisterOverlayVisible: true,
        isAccountOverlayVisible: false,
        isForgotPasswordOverlayVisible: false,
        isResetPasswordOverlayVisible: false,
      });
    }
    if (
      showSigninOverlayFlag !== prevProps.overlayFlags.showSigninOverlayFlag
    ) {
      this.setState({
        isDrawerOpen: false,
        isSigninOverlayVisible: true,
        isRegisterOverlayVisible: false,
        isAccountOverlayVisible: false,
        isForgotPasswordOverlayVisible: false,
        isResetPasswordOverlayVisible: false,
      });
    }
    if (
      showAccountOverlayFlag !== prevProps.overlayFlags.showAccountOverlayFlag
    ) {
      this.setState({
        isDrawerOpen: false,
        isSigninOverlayVisible: false,
        isRegisterOverlayVisible: false,
        isAccountOverlayVisible: true,
        isForgotPasswordOverlayVisible: false,
        isResetPasswordOverlayVisible: false,
      });
    }
    if (
      showForgotPasswordOverlayFlag !==
      prevProps.overlayFlags.showForgotPasswordOverlayFlag
    ) {
      this.setState({
        isDrawerOpen: false,
        isSigninOverlayVisible: false,
        isRegisterOverlayVisible: false,
        isAccountOverlayVisible: false,
        isForgotPasswordOverlayVisible: true,
        isResetPasswordOverlayVisible: false,
      });
    }
    if (
      showResetPasswordOverlayFlag !==
      prevProps.overlayFlags.showResetPasswordOverlayFlag
    ) {
      this.setState({
        isDrawerOpen: false,
        isSigninOverlayVisible: false,
        isRegisterOverlayVisible: false,
        isAccountOverlayVisible: false,
        isForgotPasswordOverlayVisible: false,
        isResetPasswordOverlayVisible: true,
      });
    }
  }

  showSigninOverlay = () => this.setState({ isSigninOverlayVisible: true });
  hideSigninOverlay = () => this.setState({ isSigninOverlayVisible: false });

  showRegisterOverlay = () => this.setState({ isRegisterOverlayVisible: true });
  hideRegisterOverlay = () =>
    this.setState({ isRegisterOverlayVisible: false });

  logout = () => {
    localStorage.clear();
    this.props.setEmployeeData({ employeeData: null });
    this.setState({
      isSession: 0,
      isDrawerOpen: false,
    });
    window.location.reload(false);
  };

  render() {
    return (
      <div
        className={`header-section ${
          this.props.pathName !== "/" ||
          (this.props.pathName === "/" && this.props.homeSlideId != null)
            ? "dark-header"
            : ""
        }`}
      >
        <div className="header-section-one">
          <Link
            to="/"
            onClick={() => swiper?.slideTo(0)}
            className="drexel-icon"
          >
            <img
              src={require("../assets/images/drexel icon.png")}
              // className="drexel-icon"
              alt="drexel-icon"
            />
          </Link>
          <Link onClick={() => swiper?.slideTo(0)} to="/">
            <img
              src={require("../assets/images/electrified.png")}
              className="electrified"
              alt="electrified"
            />
          </Link>
        </div>
        <div className="header-section-second" id="header-list-desktop">
          <div
            className={`header-section-two ${
              this.props.pathName === "/" ? "active" : ""
            }`}
          >
            {this.props.pathName === "/" && (
              <Link onClick={() => swiper?.slideTo(0)} to="/">
                <img
                  src={require("../assets/images/Hand img.png")}
                  className="hand-up"
                  alt="hand-up"
                />
              </Link>
            )}
            <Link className="explore-menu" to="/">
              Explore
            </Link>
          </div>
          <div
            className={`header-section-two ${
              this.props.pathName === "/stories" ? "active" : ""
            }`}
          >
            {this.props.pathName === "/stories" && (
              <Link to="/stories">
                <img
                  src={require("../assets/images/Hand img.png")}
                  className="hand-up"
                  alt="hand-up"
                />
              </Link>
            )}
            <Link className="explore-menu" to="/stories">
              Stories
            </Link>
          </div>
          <div
            className={`header-section-two ${
              this.props.pathName === "/collections" ? "active" : ""
            }`}
          >
            {this.props.pathName === "/collections" && (
              <Link to="/collections">
                <img
                  src={require("../assets/images/Hand img.png")}
                  className="hand-up"
                  alt="hand-up"
                />
              </Link>
            )}
            <Link className="explore-menu" to="/collections">
              Collections
            </Link>
          </div>
          <div
            className={`header-section-two ${
              this.props.pathName === "/about" ? "active" : ""
            }`}
          >
            {this.props.pathName === "/about" && (
              <Link to="/about">
                <img
                  src={require("../assets/images/Hand img.png")}
                  className="hand-up"
                  alt="hand-up"
                />
              </Link>
            )}
            <Link className="explore-menu" to="/about">
              About
            </Link>
          </div>
        </div>
        <div className="header-section-three">
          {this.props.employeeData?.employeeId != null && (
            <div
              className="user-profile"
              onClick={() =>
                this.setState({
                  isDrawerOpen: false,
                  isSigninOverlayVisible: false,
                  isRegisterOverlayVisible: false,
                  isAccountOverlayVisible: true,
                  isForgotPasswordOverlayVisible: false,
                  isResetPasswordOverlayVisible: false,
                })
              }
            >
              <img
                src={
                  AppConfig.API.USER_PROFILE +
                  this.props.employeeData?.employeeId
                }
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = require("../assets/images/user-icon.png");
                }}
                alt="Profile"
                className="user-icon"
              />
              <p>{this.props.employeeData?.name}</p>
            </div>
          )}
          {this.props.employeeData?.employeeId != null ? (
            <button onClick={this.logout} type="button" className="sign-out">
              Sign out
            </button>
          ) : (
            <button
              type="button"
              className="sign-in"
              onClick={() => this.setState({ isSigninOverlayVisible: true })}
            >
              Sign in
            </button>
          )}
        </div>
        <Link to="/" id="electrified-mob">
          <img
            src={require("../assets/images/electrified.png")}
            className="electrified"
            id="electrified-mob"
            alt="electrified"
          />
        </Link>
        <div className="mobile-menuicon">
          <img
            src={require("../assets/images/Menu-ICON.png")}
            className="Menu-ICON"
            alt="Menu-ICON"
            onClick={() => this.setState({ isDrawerOpen: true })}
          />
          {this.state.isDrawerOpen ? (
            <Drawer
              anchor="right"
              open={this.state.isDrawerOpen}
              onClose={() => this.setState({ isDrawerOpen: false })}
              id="set-mob-drawer"
            >
              <div id="togglemenu-mobile">
                <div className="close-icon">
                  <Whiteclose
                    className="drawerclose-icon"
                    onClick={() => this.setState({ isDrawerOpen: false })}
                  />
                </div>
                <div className="header-lineup-text">
                  <p>
                    <Link
                      to="/"
                      onClick={() => this.setState({ isDrawerOpen: false })}
                    >
                      Explore All
                    </Link>
                  </p>
                  <p>
                    <Link
                      to="/stories"
                      onClick={() => this.setState({ isDrawerOpen: false })}
                    >
                      Stories
                    </Link>
                  </p>
                  <p>
                    <Link
                      to="/collections"
                      onClick={() => this.setState({ isDrawerOpen: false })}
                    >
                      Collections
                    </Link>
                  </p>
                  <p>
                    <Link
                      to="/about"
                      onClick={() => this.setState({ isDrawerOpen: false })}
                    >
                      About Exhibit
                    </Link>
                  </p>
                  <hr></hr>
                  {this.props.employeeData?.employeeId != null && (
                    <>
                      <p>
                        <span
                          onClick={() => {
                            this.setState({ isDrawerOpen: false });
                            if (this.props.pathName === "/favorites") {
                              window.scrollTo(0, 0);
                            } else {
                              this.props.history.push("/favorites");
                            }
                          }}
                        >
                          My Favorites
                        </span>
                      </p>
                      <p>
                        <span
                          onClick={() => {
                            this.setState({
                              isDrawerOpen: false,
                              isAccountOverlayVisible: true,
                            });
                          }}
                        >
                          Account
                        </span>
                      </p>
                    </>
                  )}
                  <p>
                    <span
                      onClick={() => {
                        if (this.props.employeeData?.employeeId != null) {
                          this.logout();
                        } else {
                          this.setState({
                            isDrawerOpen: false,
                            isSigninOverlayVisible: true,
                          });
                        }
                      }}
                    >
                      {this.props.employeeData?.employeeId != null
                        ? "Log out"
                        : "Sign in"}
                    </span>
                  </p>
                </div>
              </div>
            </Drawer>
          ) : null}
          <SigninOverlay
            visible={this.state.isSigninOverlayVisible}
            close={() => this.setState({ isSigninOverlayVisible: false })}
            showSigninOverlay={this.showSigninOverlay}
            showRegisterOverlay={this.showRegisterOverlay}
            showForgotPasswordOverlay={() => {
              this.setState({
                isForgotPasswordOverlayVisible: true,
              });
            }}
          />
          <RegisterOverlay
            visible={this.state.isRegisterOverlayVisible}
            close={() => this.setState({ isRegisterOverlayVisible: false })}
            showSigninOverlay={this.showSigninOverlay}
            showRegisterOverlay={this.showRegisterOverlay}
          />
          <AccountOverlay
            visible={this.state.isAccountOverlayVisible}
            close={() => this.setState({ isAccountOverlayVisible: false })}
            history={this.props.history}
          />
          <ForgotPasswordOverlay
            visible={this.state.isForgotPasswordOverlayVisible}
            close={() =>
              this.setState({ isForgotPasswordOverlayVisible: false })
            }
            history={this.props.history}
            showSigninOverlay={this.showSigninOverlay}
          />
          {this.state.isResetPasswordOverlayVisible && (
            <ResetPasswordOverlay
              visible={this.state.isResetPasswordOverlayVisible}
              close={() =>
                this.setState({ isResetPasswordOverlayVisible: false })
              }
              history={this.props.history}
              pathName={this.props.pathName}
              showSigninOverlay={this.showSigninOverlay}
            />
          )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
